import axiosInstance from '../../../config/axios';

export interface PlatformTenant {
  id: number;
  name: string;
  owner_email: string | null;
  user_count: number;
  billing_state: string;
  trial_ends_at: string | null;
  is_design_partner: boolean;
  special_code: string;
  created_at: string | null;
}

export interface CreateTenantRequest {
  tenant_name: string;
  admin_email: string;
  password?: string;
  trial_days?: number;
  is_design_partner?: boolean;
  special_code?: string;
}

export interface UpdateTenantRequest {
  billing_state?: string;
  trial_ends_at?: string;
  is_design_partner?: boolean;
  special_code?: string;
}

export default class PlatformService {
  static async getTenants(): Promise<PlatformTenant[]> {
    const { data } = await axiosInstance.get('/api/platform/tenants/');
    return data;
  }

  static async createTenant(req: CreateTenantRequest): Promise<PlatformTenant> {
    const { data } = await axiosInstance.post('/api/platform/tenants/', req);
    return data;
  }

  static async updateTenant(tenantId: number, req: UpdateTenantRequest): Promise<PlatformTenant> {
    const { data } = await axiosInstance.patch(`/api/platform/tenants/${tenantId}/`, req);
    return data;
  }
}
